import logoSmall from "../../assets/img/logo-sm.png"

const images = {
  logoSmall,
}

export default images
